import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import StyledBase from './components/base/StyledBase';
import Preload from './components/base/Preload';
import Main from './components/views/MainView';
import LoginCheckView from './components/views/LoginCheckView';
import ER from 'error-reporting';
import * as oh from './helpers/output_helpers';

import withConfig from 'with-config';
import config from './config';

withConfig.setDefault(config);
withConfig.fetch();

let error_report_config = {
  header: 'DASHBOARD: ',
  slack_webhook: config.slack.webhook_uri,
  disable_slack_posting:
    !config.send_errors_to_slack_in_dev && !config.production,
};

ER.setConfig(error_report_config);

let LoginCheckWithER = ER.withErrorReporting(
  LoginCheckView,
  ER.ErrorAlert,
  () => {
    let prefix = 'User not logged in.';

    if (window.sso && window.sso.isLoggedIn && window.sso.isLoggedIn()) {
      let token = window.sso.getJWT();
      let token_issued = new Date(token.getClaim('iat') * 1000);
      prefix =
        'User ' +
        token.getClaim('uid') +
        '/' +
        token.getClaim('username') +
        ' iat@' +
        token_issued.toISOString();
    }

    let status = ER.getStatus();
    let label = oh.translate('sending');
    let body = [oh.translate('sending_error_report')];
    if (status === 'sent') {
      label = oh.translate('sent');
      body = [oh.translate('error_report_sent')];
    } else if (status === 'failed') {
      label = oh.translate('failed');
      body = [
        oh.translate('error_report_failed'),
        oh.translate('please_contact_us'),
      ];
    }

    return {
      prefix: prefix,
      custom_error_props: {
        title: oh.translate('error_has_occured'),
        label: label,
        body: body,
        action_label: oh.translate('go_to_start'),
        actionCB: () => {
          window.location = '/';
        },
      },
    };
  },
);

ReactDOM.render(
  <Router>
    <StyledBase>
      <LoginCheckWithER whatever={'what'}>
        <div>
          <Switch>
            <Preload>
              <Route path="/" component={Main} />
            </Preload>
          </Switch>
        </div>
      </LoginCheckWithER>
    </StyledBase>
  </Router>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js